import * as DateHelper from "@/utils/date-helper"

const DISPLAY_FORMAT = "dd/MM/yyyy HH:mm"

export interface OrderDate {
  /** Chave do rótulo em `orders.table.dates`. */
  key: "created" | "paid" | "expires" | "canceled"
  value: string
}

interface OrderDatesSource {
  createdAt?: string
  paidAt?: string
  expiresAt?: string
  canceledAt?: string
}

/**
 * As datas que importam para ESTE pedido, na ordem em que aconteceriam.
 *
 * <p>Mostrar as quatro sempre encheria a coluna de traços: pedido pago não tem cancelamento, e
 * pedido cancelado não tem por que anunciar quando expiraria. A expiração só aparece enquanto o
 * pedido está em aberto — depois de pago ou cancelado ela deixa de significar algo.</p>
 */
export const getOrderDates = (
  order: OrderDatesSource
): OrderDate[] => {
  const dates: OrderDate[] = []

  const push = (key: OrderDate["key"], raw?: string) => {
    if (!raw) return
    const value = DateHelper.formatDate(raw, DISPLAY_FORMAT)
    if (value) dates.push({ key, value })
  }

  push("created", order.createdAt)
  push("paid", order.paidAt)
  push("canceled", order.canceledAt)

  const isSettled = Boolean(order.paidAt || order.canceledAt)
  if (!isSettled) push("expires", order.expiresAt)

  return dates
}
